angular.module('callX').controller('AgentDashboardCtrl', ['$scope','$stateParams','$modal','$anchorScroll','UserService', '$state', 'toaster', '$http', function($scope,$stateParams,$modal,$anchorScroll,UserService,$state, toaster, $http) {
    
    var username_agent = $stateParams.username;
    var userId = $stateParams.userId;
    //console.log($stateParams,"this are stateParams")
    $scope.callClosed = false;
    $scope.answeredCall = false;
    $scope.offerDetailsFlag = false;
    $scope.liveNow = false;
    $scope.incomingCallRinging = false;
    $scope.totalLayout = false;
    $scope.salesLayout = false;
    $scope.dynamicLayout = false;
    $scope.totalAnswered = false;
    $scope.showAlertModel = true; 
    $scope.showDataModel = false;
    $scope.role ;
    $scope.getuserRole ;
    $scope.getsalesRole ;
    $scope.onHangupCallStatus = false;
    $scope.switchStatus = true;

    $scope.frwdOfferData={};//added     
     $scope.validateCount=0;//added 
     $scope.tableContentLoading=false; //added
     $scope.optionsArrCreate=[];
     $scope.forwardflag = false;
     $scope.rightblock=false;
     var timer,timerInter;
     $scope.sidecondition=false;
     //document.getElementsByClassName("leadDisable").style.disabled=true;
     $scope.staticCustomerDetails = {
        first_name: "",
        last_name: "",
        gender: null,
        email: null,
        street1: "",
        street2: "",
        zip_code: null,
        dobDay: "",
        dobMonth: "",
        dobYear: "",
        age:"",
        height_feet: "",
        height_inches: "",
        weight: "",
        face_value: "",
        tobacco_user: null,
        bank_account: null,
        selectionDiesases: []
    };
    $scope.staticPriorityDetails = [];
     $scope.heightArray = ['5 feet 10 inches', '5 feet 11 inches'];
     $scope.diseasesList = ['Cancer', 'Diabetes', 'Anxiety /Depression /Bipolar','Heart Disorder', 'Chronic Pain',' Respiratory Disorder', 'Other Medical conditions','I have no medical conditions'];

     // Selected fruits
     $scope.selectionDiesases = [];
     $scope.staticQuestionsLayout = false;
     $scope.staticPriorityLayout = false;
     $scope.salesDisposition = false;
     $scope.editingFaceValue = false;
     $scope.editFaceValue = {};
     $scope.salesEndDisposition = false;
     $scope.loading = false;
     $scope.showNoOffersMessage = false;
     $scope.editSalesScript = false;
     $scope.editData = {}

     $scope.selectedDisposition = {
        value: ''
     };

     // Toggle selection for a given disease by name
     $scope.toggleSelection = function(val) {
       var idx = $scope.staticCustomerDetails.selectionDiesases.indexOf(val);
   
       // Is currently selected
       if (idx > -1) {
        $scope.staticCustomerDetails.selectionDiesases.splice(idx, 1);
       }
   
       // Is newly selected
       else {
        $scope.staticCustomerDetails.selectionDiesases.push(val);
       }
     };

     $scope.toggleEditSelection = function(val) {
        var idx = $scope.editData.selectionDiesases.indexOf(val);
    
        // Is currently selected
        if (idx > -1) {
         $scope.editData.selectionDiesases.splice(idx, 1);
        }
    
        // Is newly selected
        else {
         $scope.editData.selectionDiesases.push(val);
        }
      };

      $scope.isAtLeastOneDiseaseSelected = function() {
        return $scope.staticCustomerDetails.selectionDiesases.some(function(disease) {
            return disease;
        });
    };

     $scope.months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
     $scope.years = [];
        var currentYear = new Date().getFullYear();
            for (var year = 1950; year <= currentYear; year++) {
            $scope.years.push(year);
        } 

    $scope.faceValues = [5000, 10000, 15000, 20000, 25000, 30000, 35000, 40000, 45000, 50000];

    $scope.updateDays = function() {
        var selectedYear = parseInt($scope.staticCustomerDetails.dobYear);
        var selectedMonth = parseInt($scope.staticCustomerDetails.dobMonth);
        var maxDays;
        switch (selectedMonth) {
          case 2: 
            var selectedYear = parseInt($scope.staticCustomerDetails.dobYear);
            maxDays = (selectedYear % 4 === 0 && (selectedYear % 100 !== 0 || selectedYear % 400 === 0)) ? 29 : 28; // Leap year calculation
            break;
          case 4: 
          case 6:
          case 9: 
          case 11:
            maxDays = 30;
            break;
          default:
            maxDays = 31;
        }
        $scope.maxDays = maxDays;
        $scope.days = [];

        for (var i = 1; i <= maxDays; i++) {
          $scope.days.push(i);
        }

    }
    $scope.calculateAge = function() {
        var currentYear = new Date().getFullYear();
        var birthYear = parseInt($scope.staticCustomerDetails.dobYear);
        var age = currentYear - birthYear;
        $scope.staticCustomerDetails.age = age;
      };

      $scope.calculateEditAge = function() {
        var currentYear = new Date().getFullYear();
        var birthYear = parseInt($scope.editData.dobYear);
        var age = currentYear - birthYear;
        $scope.editData.age = age;
      }

      
    //static question form data start
     $scope.nexQuestion = function() {
        $scope.staticCustomerDetails.email = $scope.salesuserEmail;
        var data = $scope.staticCustomerDetails;
        $scope.editFaceValue.value = $scope.staticCustomerDetails.face_value;
        data.agent_id = parseInt(userId)
        data.caller_id = $scope.strNumber;
        // console.log("get caller id value",caller_id);
        // $scope.callerId = data.caller_id;
        console.log("data of staticquestions",data,data.caller_id,data.agent_id);
        $scope.loading = true;
        var callbacks = {   
            success: function(data) {
                $scope.staticQuestionsLayout = false;
                $scope.staticPriorityLayout = true;
                $scope.staticPriorityDetails = data.data;
                console.log( $scope.staticPriorityDetails)
                if($scope.staticPriorityDetails.length === 0){
                    $scope.showNoOffersMessage = true;
                    $scope.loading = false;
                }
                else {
                    $scope.loading = false;
                    $scope.showNoOffersMessage = false;
                }
            },
            failure: function(data) {
                toaster.pop('error', 'Error', data.data);
                $scope.loading = false;
            },
        };
        UserService.postStaticQuestions(data,callbacks);
    }
     

    //navigate eapplink to new window start
    $scope.openNewWindow = function(eapplink){
        console.log(eapplink, "get url")
        // window.open(eapplink);
        window.open(
            eapplink,
            'NewTab',
            'height=400,width=400'
          );
    }

    //updated face value in carrier page start
    $scope.updateFaceValue = function() {
        $scope.loading = true;
        if (!$scope.editingFaceValue) {
            $scope.editingFaceValue = true;
        }
        var updateFaceData =  JSON.parse(JSON.stringify($scope.staticCustomerDetails));
        updateFaceData.face_value = $scope.editFaceValue.value;
        var callbacks = {   
            success: function(data) {
                $scope.staticQuestionsLayout = false;
                $scope.staticPriorityLayout = true;
                $scope.staticPriorityDetails = data.data;
                $scope.staticCustomerDetails.face_value =  $scope.editFaceValue.value;
                // $scope.loading = false;
                if($scope.staticPriorityDetails.length === 0){
                    $scope.showNoOffersMessage = true;
                    $scope.loading = false;
                }else {
                    $scope.loading = false;
                    $scope.showNoOffersMessage = false;
                }
            },
            failure: function(data) {
                toaster.pop('error', 'Error', data.data);
                $scope.loading = false;
            }
        };
        UserService.postStaticQuestions(updateFaceData,callbacks);
    };
    

    $scope.backButton = function(){
        if($scope.staticPriorityLayout == true){
            $scope.staticQuestionsLayout = true;
            $scope.staticPriorityLayout = false;
            $scope.showNoOffersMessage = false;
            $scope.onHangupCallStatus = false;
        }else if($scope.salesDisposition == true){
            $scope.staticPriorityLayout = true;
            $scope.salesDisposition = false;
            $scope.onHangupCallStatus = false;
        }
    }

    $scope.endCall = function(){
        // console.log("open disposition page")
        if($scope.staticQuestionsLayout == true){
            $scope.staticQuestionsLayout = false;
            $scope.salesDisposition = true;
        }else if($scope.staticPriorityLayout == true){
            $scope.staticPriorityLayout = false;
            $scope.salesDisposition = true;
        }
    }

    $scope.endCallAndDeposition = function() {
        $scope.onHangupCallStatus = true;
        // console.log("make call status to on pause", $scope.onHangupCallStatus)
        $scope.staticPriorityLayout = false;
        $scope.totalLayout = false;
        $scope.dynamicLayout = false;
        $scope.salesDisposition = true;
    }

    //edit static question start
    $scope.editsalesPanel = function(){
        $scope.editSalesScript = true;
        $scope.editData = angular.copy($scope.staticCustomerDetails);
        $scope.editData.email = $scope.staticCustomerDetails.email;
        console.log("gets edit scope details", $scope.editData.face_value);
    }

    //save static questions start
    $scope.savesalesPanel = function() {
        $scope.editSalesScript = false;
        $scope.staticCustomerDetails = angular.copy($scope.editData);
        $scope.editFaceValue.value = $scope.staticCustomerDetails.face_value;
        var existingDisease = $scope.staticCustomerDetails.selectionDiesases;
        var newDiseases = Object.entries($scope.editData.selectionDiesases).filter(function(disease) {
            return (
              $scope.editData.selectionDiesases[disease] &&
              !existingDisease.includes(disease)
            );
          })
          $scope.staticCustomerDetails.selectionDiesases =  existingDisease.concat(newDiseases).filter(function(disease){
            return disease !== undefined;
          });

        // console.log("get save details", $scope.staticCustomerDetails);
        var updateData = $scope.staticCustomerDetails;
        var callbacks = {   
            success: function(data) {
                if( $scope.staticQuestionsLayout == true){
                    $scope.staticQuestionsLayout = true;
                }
                else if($scope.staticPriorityLayout == true){
                    $scope.staticPriorityLayout = true;    
                }else if($scope.salesDisposition == true){
                    $scope.salesDisposition = true;
                }
                $scope.staticPriorityDetails = data.data;
            },
            failure: function(data) {
                toaster.pop('error', 'Error', data.data);
            }
        };
        UserService.postStaticQuestions(updateData,callbacks);
    }
    

    //sales agent status details start
    $scope.getsalesAgentStats = function(){
        var callbacks = {
            success: function(data) {
                $scope.userStats = data.data; 
                // console.log($scope.userStats,"get salesagent data")      
            },
            failure: function(data) {
                toaster.pop('error', 'Error', data.data);
            }
        };
        UserService.getSalesDashboardDetails(userId,$scope.getsalesRole,callbacks);
    };

    $scope.getAgentStats = function(){
        var callbacks = {
            success: function(data) {
                $scope.userStats = data.data;
                // console.log($scope.userStats, "get agent details")      
            },
            failure: function(data) {
                toaster.pop('error', 'Error', data.data);
            }
        };
        UserService.getDashboardDetails(userId,$scope.getuserRole,callbacks);
    };

    $scope.setAgentFirsAandLastName = function() {
        $scope.username_firstName = window.localStorage.getItem("first_name")
        $scope.username_lastName = window.localStorage.getItem("last_name")
        $scope.user_id = window.localStorage.getItem("user_id")
        $scope.role = window.localStorage.getItem("role")
        $scope.email = window.localStorage.getItem("email")
        if($scope.role == 'useragent'){
            $scope.getuserRole = $scope.role;
            $scope.getAgentStats();
        }else if($scope.role == 'salesagent'){
            $scope.getsalesRole = $scope.role;
            $scope.getsalesAgentStats();
        }
    }

    $scope.limitTextLength = function(text) {
        return text.slice(0,4) + '..'
    }

    $scope.setAgentFirsAandLastName();
   
    //repeatedly hitting server to check net connectivity -start
    //  window.clearInterval(timerInter);
    //         timerInter = window.setInterval(function(){
    //      if($scope.statusValue=='online' || $scope.statusValue=='offline'){ //added -agent logged in status
    //             $scope.postConnectionDetails();
    //             console.log("connection");
    //     }
    // },30000); 

    // window.setInterval(function(){
    //    /* if($scope.statusValue=='online'){*/  //check condition for internet
    //      if($scope.statusValue=='online' || $scope.statusValue=='offline'){ //added -agent logged in status
    //             $scope.postConnectionDetails();
    //             console.log("connection");
    //     }
    // },30000); 
    

    $scope.postConnectionDetails = function(){
            var callbacks = {
                success: function(data) {
                },
                failure: function(data) {
                 }   
            }
        UserService.postConnectionDetails(userId,$scope.role,callbacks);
    }

     //repeatedly hitting server to check net connectivity -end

    //added -agent logged in status - start
    //   $scope.postConnectionDetails();

    //added -agent logged in status - end
    
    $scope.getCallerDetails = function(id){
        var callbacks = {
            success: function(data) {
                $scope.userDetails = data.data;
                $scope.userCallId = data.data.id;            
            },
            failure: function(data) {
                toaster.pop('error', 'Error', data.data);
            }
        };
        UserService.getUserDetails(id,$scope.getuserRole,callbacks);
    };
   

    $scope.getsalesCallerDetails = function(id){
        // Rush callback flow pre-creates the Call + customer server-side
        // BEFORE the SDK dial (see RushOpportunitiesCtrl.doClaimAndCall).
        // When that path runs, $rootScope.salesuserCallId is already set
        // and $rootScope.activeRushCustomer holds the SalesAgentContactDTO,
        // so re-fetching from /wapi/salesagent/contact/details would
        // overwrite the correct ids with stale data (or fail entirely if
        // the inbound contact does not exist yet).
        if ($rootScope && $rootScope.salesuserCallId && $rootScope.activeRushOpportunityId) {
            console.log('[Rush] skipping inbound caller lookup, salesuserCallId already set by Rush:', $rootScope.salesuserCallId);
            $scope.salesuserCallId = $rootScope.salesuserCallId;
            if ($rootScope.activeRushCustomer) {
                $scope.salesuserDetails = $rootScope.activeRushCustomer;
                $scope.salesuserEmail   = $rootScope.activeRushCustomer.email;
            }
            return;
        }
        var callbacks = {
            success: function(data) {
                // console.log(data.data.email,"get sales agent data")
                $scope.salesuserDetails = data.data;
                $scope.salesuserCallId = data.data.id;
                 // console.log('$scope.salesuserDetails,',$scope.salesuserDetails);
                // console.log('$scope.salesuserCallId',$scope.salesuserCallId);
                $scope.salesuserEmail = data.data.email;  
                data.data.email = $scope.staticCustomerDetails.email;       
            },
            failure: function(data) {
                toaster.pop('error', 'Error', data.data);
            }
        };
        UserService.getSalesUserDetails(id,$scope.getsalesRole,callbacks);
    };

    $scope.getIVRDetails = function(id){
        console.log("get IVR details",id)
        $scope.forwardflag=false;
        $scope.rightblock=false;
        $scope.filterobj={};
        $scope.sidecondition=false;
        $scope.scriptDetails={};
        var callbacks = {
            success: function(data) {
                $scope.scriptResponse=data.data; //added
                $scope.scriptDetails = data.data.headers;
                console.log($scope.scriptDetails,"get total data ")
                $scope.scriptCallId = data.data.call_id;
                console.log("get script CALL ID",$scope.scriptCallId);
                for(var i=0;i<=$scope.scriptDetails.length;i++){
                    if($scope.scriptDetails[i]){
                        if($scope.scriptDetails[i].header_type.code == 'askseriesofquestions'){
                            $scope.seriesQuestionsObject = $scope.scriptDetails[i].questions;
                        }
                    }
                }

              },
            failure: function(data) {
                toaster.pop('error', 'Error', data.data);
            }
        };
        UserService.getIVRDetails(id, userId, callbacks);
    };

    $scope.meal_index = 0;
    $scope.meal_index_1 = 0;
    $scope.meal = {};

    $scope.nextQuestion = function () {
        if ($scope.meal_index >= $scope.scriptDetails.length - 1) {
            $scope.meal_index = 0;
        } else {
            $scope.meal_index++;
        }
        if($scope.meal_index+1 == $scope.scriptDetails.length){
            //console.log("equaled")
        }
    };

    $scope.back = function () {
        if ($scope.meal_index <= $scope.scriptDetails.length + 1) {
            $scope.meal_index = 0;
        } else {
            $scope.meal_index--;
        }
        if($scope.meal_index == $scope.scriptDetails.length){
            //console.log("no back")
        }
    };

    $scope.next_1 = function () {
        if ($scope.meal_index_1 >= $scope.seriesQuestionsObject.length - 1) {
            $scope.meal_index_1 = 0;
        } else {
            $scope.meal_index_1++;
        }
        if($scope.meal_index_1+1 == $scope.seriesQuestionsObject.length){
            //console.log("equaled")
        }
    };

    $scope.back_1 = function () {
        if ($scope.meal_index_1 <= $scope.seriesQuestionsObject.length + 1) {
            $scope.meal_index_1 = 0;
        } else {
            $scope.meal_index_1--;
        }
        if($scope.meal_index_1 == $scope.seriesQuestionsObject.length){
            //console.log("no back")
        }
    };

    $scope.getButton = function(lead_fieldCode,txt) {
        if(lead_fieldCode === 'zipcode'){
            var user_zipcode = txt.responseTextInputSeries;
                if (user_zipcode && user_zipcode.length === 5 ) {
                    var callbacks = {
                        success: function(data) {
                            if (data.data) {
                                $scope.location = data.data;
                            } 
                        },
                        failure: function(data) {
                            toaster.pop('error', 'Error', data.data);
                            $scope.location = {};
                        }
                    };
                    UserService.getStateCity(user_zipcode, callbacks);
                } else {
                    $scope.location = {};
                }
        }
    var bt = document.getElementById('btSubmit');
      if(lead_fieldCode === 'email'){
        if(txt.responseTextInputSeries === null || txt.responseTextInputSeries != ''){
            bt.disabled = false;
            bt.style.background = "#2196f3";
            bt.style.color = "white";
        }
      }
      else {
        if (txt.responseTextInputSeries != '') {
            bt.disabled = false;
            bt.style.background = "#2196f3";
            bt.style.color = "white";
        }
        else {
            bt.disabled = true;
            bt.style.background = "grey";
            bt.style.color = "white";
        }
      }  
    } 

    $scope.getButton1 = function(txt) {
        var bt1 = document.getElementById('btSubmit1');
        if (txt.responseTextInputSingle != '') {
            bt1.disabled = false;
            bt1.style.background = "#2196f3";
            bt1.style.color = "white";
        }
        else {
            bt1.disabled = true;
            bt1.style.background = "grey";
            bt1.style.color = "white";
        }
    } 

    $scope.getButton2 = function(txt) {
        var bt2 = document.getElementById('btSubmit2');
        if (txt.responseTextInputVerify != '') {
            bt2.disabled = false;
            bt2.style.background = "#2196f3";
            bt2.style.color = "white";
        }
        else {
            bt2.disabled = true;
            bt2.style.background = "grey";
            bt2.style.color = "white";
        }
    } 

    // $scope.postAnswerAgentStatus = function(){
    //     console.log("entered answered")
    //         var callbacks = {
    //             success: function(data) {
    //             },
    //             failure: function(data) {
    //                 toaster.pop('error', 'Error', data.data);
    //             }
    //         };
    //     UserService.postAgentAvailable({"answered":true},userId,callbacks);
    // }

    $scope.postAgentBusyStatus = function(){
            var callbacks = {
                success: function(data) {
                    $scope.agstatus='busy'; //added
                },
                failure: function(data) {
                    toaster.pop('error', 'Error', data.data);
                }
            };
        UserService.postAgentStatusUpdate({"status":'busy'},userId,$scope.role,callbacks);
    }

    $scope.postAgentAvailableStatus = function(){
            var callbacks = {
                success: function(data) {
                    $scope.agstatus='available';
                    if($scope.role == 'useragent'){
                        $scope.getAgentStats();
                    }else if($scope.role == 'salesagent'){
                        $scope.getsalesAgentStats();
                    }
                },
                failure: function(data) {
                    toaster.pop('error', 'Error', data.data);
                }
            };
        UserService.postAgentStatusUpdate({"status":'available'},userId,$scope.role,callbacks);
        }


        $scope.checkZipcode = function() {
            // console.log("get response")
            var check_zipcode = $scope.staticCustomerDetails.zip_code;
            if (check_zipcode && check_zipcode.length === 5 ) {
                var callbacks = {
                    success: function(data) {
                        if (data.data) {
                            $scope.location = data.data;
                        } 
                    },
                    failure: function(data) {
                        toaster.pop('error', 'Error', data.data);
                        $scope.location = {};
                    }
                };
                UserService.getStateCity(check_zipcode, callbacks);
            } else {
                $scope.location = {};
            }
        };

    $scope.putTransferAgentStatus = function(){
            var callbacks = {
                success: function(data) {
                    if($scope.role == 'useragent'){
                        $scope.getAgentStats();
                    }else if($scope.role == 'salesagent'){
                        $scope.getsalesAgentStats();
                    }
                },
                failure: function(data) {
                    toaster.pop('error', 'Error', data.data);
                }
            };
        //UserService.putAgentTransferStatus(userId,callbacks);
        UserService.putAgentTransferStatus(userId,$scope.scriptCallId,callbacks);
    }

    $scope.dataNew = {};
    $scope.dataNew.emptyObject = "";

    $scope.updateLeadFields = function(code,answer){
        //console.log(code,answer,"called in updateLeadFields")
        var callbacks = {
                success: function(data) {
                    $scope.modifyPhoneNumberUser($scope.phoneNumberIncoming)
                },
                failure: function(data) {
                    toaster.pop('error', 'Error', data.data);
                }
            };
        UserService.updateLeadField({"id":$scope.userCallId,"macros":[{"key":code,"value":answer}]},callbacks);
    }


    $scope.disableEdit = function () {
        $("#sideLeadfield input").prop( "disabled", true );
        $("#sideLeadfield select").prop( "disabled", true );     
        $("#edit_right").prop( "disabled", true );
        $("#save_right").prop( "disabled", true );
     }


    $scope.displayOffersTable = function (data) {

        if (data.data) {
            $scope.offerErrorCode=data.statusCode;      
            $scope.offerErrorMsg=data.message;      
            $scope.frwdOfferData = data.data;        
            $scope.frwdOfferData2=$scope.frwdOfferData; 
            $scope.disableEdit();
            if(data.statusCode==200){        
                document.getElementById("offerListFrwd").style.display='table';     
                //document.getElementById("offerStmt").style.display='block'; 
                document.getElementById("offerStmt").style.visibility='visible';   
    
                var modal5 = document.getElementById("myModal5");
                if (modal5) modal5.style.display = "none";
                //added
               
                if($scope.forwardData.read_data!=null){
                    if(($scope.forwardData.read_data).includes("{offer_display_name}")){
                        $scope.forwardData.read_data=($scope.forwardData.read_data).replace(/{offer_display_name}/g,$scope.frwdOfferData[0].offer_name);
                    }
                  
                          document.getElementById("myModal1").style.display='block';      
                            document.getElementById("myModal1").style.opacity=1;        
                            document.getElementById("myModal1").style.backgroundColor = 'rgb(' + 0 + ',' +0 + ',' + 0 + ',' +0.34 +')';     
                            
                    } 
                }
        }

    }

    $scope.nextAskSeries = function(userAnswer,questions,optId,index,answer){
        // editscript --> storing the response - start
        /*if(userAnswer != ""){
         questions[index].response=userAnswer;
         $scope.rightblock=true;
        }
        if((userAnswer == undefined && answer != "")||(userAnswer == "" && answer != "")){
         questions[index].response=answer;
         $scope.rightblock=true;
         }*/
        // editscript --> storing the response - end

        //email validation

        if(questions[index].options[0].lead_field!=undefined){

            //all fields check
            /*if(questions[index].options[0].lead_field.code!="dob" && questions[index].options[0].lead_field.code!="email" && questions[index].options[0].lead_field.code!="zipcode" && answer == ""){*/
            if(questions[index].options[0].lead_field.code != 'email'){
                    if(answer == ""){
                            if(userAnswer == undefined){ 
                                    toaster.pop('error', 'Error', 'Please enter vaild data',2000);
                                $scope.validateCount=1;
                            }
                            else{
                                $scope.validateCount=0;
                            }        
                    }
            }

            //dob validation dob
            if(questions[index].options[0].lead_field.code=="dob" && answer == ""){
                console.log(userAnswer, "dob")
                if((userAnswer).match(/^([0-9]{2})\/([0-9]{2})\/([0-9]{4})$/)){
                     $scope.validateCount=0;
                }
                else{
                     toaster.pop('error', 'Error', 'Please enter vaild date',2000);
                      $scope.validateCount=1;
                    }
            }
            //email validation
            //   if(questions[index].options[0].lead_field.code=="email"){
            //     console.log(userAnswer,"email")
            //     userAnswer=userAnswer.toLowerCase(); //added
            //     if((userAnswer).match(/^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/)){
            //         $scope.validateCount=0;
            //     }
            //     else{
            //          toaster.pop('error', 'Error', 'Please enter vaild email address',2000);
            //           $scope.validateCount=1;
            //         }
            // }
            if (questions[index].options[0].lead_field.code == "email") {
                userAnswer = userAnswer ? userAnswer.toLowerCase() : "";

                if (userAnswer == '' || userAnswer.match(/^$|^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/)) {
                  $scope.validateCount = 0; // Email is valid
                } else {
                    if(userAnswer.length !== null && userAnswer !== ''){
                        toaster.pop('error', 'Error', 'Please enter a valid email address', 2000);
                    }
                  $scope.validateCount = 1; // Email is invalid
                }
              }

            //zipcode validation

            if(questions[index].options[0].lead_field.code=="zipcode" && answer == ""){
                console.log(userAnswer,"zipcode")
                if((userAnswer).match(/^[0-9]{5}$/)){
                     $scope.validateCount=0;
                }
                else{
                     toaster.pop('error', 'Error', 'Please enter vaild zipcode',2000);
                      $scope.validateCount=1;
                    }
            }


        if($scope.validateCount==0)
        { //newly added
            if(answer == ""){
                var callbacks = {
                    success: function(data) {
                        if(data.message == 'Data saved successfully' || data.message == 'Fetch List Of Offers'){
                        //toaster.pop('success', 'Success', 'Data saved successfully', 2000);
                        if(questions.length == index+1){
                            $scope.nextQuestion();
                        }else{
                            $scope.next_1();
                        }

                       // editscript --> storing the response - start
                        if(userAnswer != ""){
                         questions[index].response=userAnswer;
                         $scope.rightblock=true;
                        }
                        if((userAnswer == undefined && answer != "")||(userAnswer == "" && answer != "")){
                         questions[index].response=answer;
                         $scope.rightblock=true;
                         }

                         $("#sideLeadfield input").prop( "disabled", true );
                            $("#sideLeadfield select").prop( "disabled", true );     
                            $("#edit_right").prop( "disabled", false );
                            $("#save_right").prop( "disabled", true );
                        // editscript --> storing the response - end


                        $scope.updateLeadFields(questions[index].options[0].lead_field.code,userAnswer);
                        $scope.displayOffersTable(data);
                    }else{
                        //console.log("entered else in answer == ''l")
                        toaster.pop('success', 'Success', 'Forwarding the call', 2000);
                        $scope.meal_index = 0;
                        $scope.meal_index_1 = 0;
                        $scope.dataNew = {};
                        $scope.totalLayout = false;
                        $scope.salesLayout = false;
                        $scope.dynamicLayout = false;
                        $scope.incomingCallRinging = false;
                        $scope.putTransferAgentStatus();

                    }
                },
                failure: function(data) {
                    toaster.pop('error', 'Error', data.message);
                }
            };
            UserService.postAgentActions({"value":userAnswer},optId,$scope.scriptCallId,callbacks);
        }
        else{
            //console.log("entered else of answer == ''")
            var callbacks = {
                success: function(data) {
                    if(data.message == 'Data saved successfully' || data.message == 'Fetch List Of Offers'){
                        if(questions.length == index+1){
                            $scope.nextQuestion();
                        }else{
                            $scope.next_1();
                        }

                        // editscript --> storing the response - start
                        if(userAnswer != ""){
                         questions[index].response=userAnswer;
                         $scope.rightblock=true;
                        }
                        if((userAnswer == undefined && answer != "")||(userAnswer == "" && answer != "")){
                         questions[index].response=answer;
                         $scope.rightblock=true;
                         }

                         $("#sideLeadfield input").prop( "disabled", true );
                            $("#sideLeadfield select").prop( "disabled", true );     
                            $("#edit_right").prop( "disabled", false );
                            $("#save_right").prop( "disabled", true );
                        // editscript --> storing the response - end
                        $scope.displayOffersTable(data);

                        //toaster.pop('success', 'Success', 'Data saved successfully', 2000);
                    }
                    else{
                        //console.log("entered else of else")
                        toaster.pop('success', 'Success', 'Forwarding the call', 2000);
                        $scope.meal_index = 0;
                        $scope.meal_index_1 = 0;
                        $scope.dataNew = {};
                        $scope.totalLayout = false;
                        $scope.salesLayout = false;
                        $scope.incomingCallRinging = false;
                    }
                },
                failure: function(data) {
                    toaster.pop('error', 'Error', data.message);
                }
            };
            UserService.postAgentActions({"value":answer},optId,$scope.scriptCallId,callbacks);
        }

        }//added for else

    }
     ////////////previous else
        else{ 
         if(answer == ""){
            //console.log("entered answer == ''")
            var callbacks = {
                success: function(data) {
                    if(data.message == 'Data saved successfully' || data.message == 'Fetch List Of Offers'){
                        //toaster.pop('success', 'Success', 'Data saved successfully', 2000);
                        if(questions.length == index+1){
                            $scope.nextQuestion();
                        }else{
                            $scope.next_1();
                        }
                       // editscript --> storing the response - start
                        if(userAnswer != ""){
                         questions[index].response=userAnswer;
                         $scope.rightblock=true;
                        }
                        if((userAnswer == undefined && answer != "")||(userAnswer == "" && answer != "")){
                         questions[index].response=answer;
                         $scope.rightblock=true;
                         }

                         $("#sideLeadfield input").prop( "disabled", true );
                            $("#sideLeadfield select").prop( "disabled", true );     
                            $("#edit_right").prop( "disabled", false );
                            $("#save_right").prop( "disabled", true );
                        // editscript --> storing the response - end
                        $scope.displayOffersTable(data);

                        // $scope.updateLeadFields(questions[index].options[0].lead_field.code,userAnswer);
                    }else{
                        //console.log("entered else in answer == ''l")
                        toaster.pop('success', 'Success', 'Forwarding the call', 2000);
                        $scope.meal_index = 0;
                        $scope.meal_index_1 = 0;
                        $scope.dataNew = {};
                        $scope.totalLayout = false;
                        $scope.incomingCallRinging = false;
                        $scope.putTransferAgentStatus();

                    }
                },
                failure: function(data) {
                    toaster.pop('error', 'Error', data.message);
                }
            };
            UserService.postAgentActions({"value":userAnswer},optId,$scope.scriptCallId,callbacks);
        }
        else{
            //console.log("entered else of answer == ''")
            var callbacks = {
                success: function(data) {
                    if(data.message == 'Data saved successfully' || data.message == 'Fetch List Of Offers'){
                        if(questions.length == index+1){
                            $scope.nextQuestion();
                        }else{
                            $scope.next_1();
                        }
                        // editscript --> storing the response - start
                        if(userAnswer != ""){
                         questions[index].response=userAnswer;
                         $scope.rightblock=true;
                        }
                        if((userAnswer == undefined && answer != "")||(userAnswer == "" && answer != "")){
                         questions[index].response=answer;
                         $scope.rightblock=true;
                         }

                         $("#sideLeadfield input").prop( "disabled", true );
                            $("#sideLeadfield select").prop( "disabled", true );     
                            $("#edit_right").prop( "disabled", false );
                            $("#save_right").prop( "disabled", true );
                        // editscript --> storing the response - end
                        $scope.displayOffersTable(data);

                        //toaster.pop('success', 'Success', 'Data saved successfully', 2000);
                    }
                    else{
                        //console.log("entered else of else")
                        toaster.pop('success', 'Success', 'Forwarding the call', 2000);
                        $scope.meal_index = 0;
                        $scope.meal_index_1 = 0;
                        $scope.dataNew = {};
                        $scope.totalLayout = false;
                        $scope.incomingCallRinging = false;
                    }
                },
                failure: function(data) {
                    toaster.pop('error', 'Error', data.message);
                }
            };
            UserService.postAgentActions({"value":answer},optId,$scope.scriptCallId,callbacks);
        }

    }//added for else

    }

    $scope.gotoNextScript = function(){
        $scope.flagElement2 = true;
        $scope.flagElement1 = false;
    }
    $scope.modifyPhoneNumberUser = function(id){
        $scope.phoneNumberPlivo = id.split('@');
        $scope.strNumber = $scope.phoneNumberPlivo[0].substring(1);
        console.log($scope.strNumber);
        if($scope.role == 'useragent'){
            $scope.getCallerDetails($scope.strNumber);
        }else if ($scope.role == 'salesagent'){
            $scope.getsalesCallerDetails($scope.strNumber);
        }
    }  
    
    $scope.modifyPhoneNumberIVR = function(id){
        $scope.phoneNumberPlivo = id.split('@');
        $scope.strNumber = $scope.phoneNumberPlivo[0].substring(1);
        $scope.getIVRDetails($scope.strNumber);
    } 
   

    /*$scope.saveLeadUserDetails = function(){
        var callbacks = {
            success: function(data) {
                
                $scope.modifyPhoneNumberUser($scope.phoneNumberIncoming);
                //added     
                var div_lead=document.getElementById("sideLeadfield");      
                var input_lead=div_lead.querySelectorAll("input");      
                    input_lead[0].disabled=true;        
                    input_lead[1].disabled=true;        
                    input_lead[2].disabled=true;        
                    input_lead[3].disabled=true;        
                    input_lead[5].disabled=true;        
                    input_lead[6].disabled=true;        
                    input_lead[9].disabled=true;        
                document.getElementById("edit_lead").style.display="inline-block";
            },
            failure: function(data) {
                toaster.pop('error', 'Error', data.data);
            }
        };
        UserService.postUserDetails($scope.userDetails,callbacks);
    }   
*/

/*$scope.saveLeadUserDetails = function(){
    
                $scope.userDetails.first_name = $("input[name='first_name']").val();
                $scope.userDetails.last_name = $("input[name='last_name']").val();
                $scope.userDetails.email = $("input[name='email']").val();
                $scope.userDetails.dob = $("input[name='dob']").val();
                $scope.userDetails.street1 = $("input[name='street1']").val();
                $scope.userDetails.street2 = $("input[name='street2']").val();
                $scope.userDetails.city = $("input[name='city']").val();
                $scope.userDetails.state = $("input[name='state']").val();
                $scope.userDetails.zipcode = $("input[name='zipcode']").val();   
                  
        var callbacks = {
            success: function(data) {
                
                $scope.modifyPhoneNumberUser($scope.phoneNumberIncoming);

            },
            failure: function(data) {
                toaster.pop('error', 'Error', data.data);
            }
        };
        UserService.postUserDetails($scope.userDetails,callbacks);
    }*/   


    $scope.playAudio = function() {
            var audio = new Audio('https://s3.amazonaws.com/freecodecamp/simonSound2.mp3');
            audio.play();
    };

    $scope.answerW = function(){
        $scope.answeredCall = true;
        $scope.totalAnswered = true;
        //console.log("call answered")
        $('#status_txt').text('Answering....');
        plivoWebSdk.client.answer();
        $('#status_txt').text('Answered the Call');
        $('#btn-container').show();
        $('#incoming_callbox').hide();
        $scope.postAgentBusyStatus();
    } 

    // $scope.answerW = function(){
    //     // play audio and after audio ends answer the call
    //     var audio = new Audio('img/short-beep-countdown.mp3');

    //     audio.addEventListener('ended', function() {
    //         $scope.$apply(function() {
    //             $scope.answeredCall = true;
    //             $scope.totalAnswered = true;
    //             //console.log("call answered")
    //             $('#status_txt').text('Answering....');
    //             plivoWebSdk.client.answer();
    //             $('#status_txt').text('Answered the Call');
    //             $('#btn-container').show();
    //             $('#incoming_callbox').hide();
    //             $scope.postAgentBusyStatus();            
    //         });
    //     });

    //     audio.play();
    // }

    $scope.rejectW = function(){
        $scope.callClosed = true;
        $scope.answeredCall = false;
        $scope.incomingCallRinging = false;
        if($scope.getuserRole == 'useragent'){
            $scope.totalLayout = false;
            $scope.dynamicLayout = false;
        }else if($scope.getsalesRole == 'salesagent'){
            $scope.salesLayout = false;
            $scope.staticQuestionsLayout = false;
        }
        $('#status_txt').text('Rejected the Call');
        plivoWebSdk.client.reject();
        $('#btn-container').hide();
        $('#incoming_callbox').hide();
        $('#status_txt').text('Ready');
    }

    $scope.userIncomingCall = function(callerName, extraHeaders){
        $scope.incomingCallRinging = true;
        $scope.phoneNumberIncoming = callerName;
        $scope.totalLayout = true;
        $scope.dynamicLayout = true;
         $scope.getAgentStats();
        // $scope.getCallerDetails();
        $scope.modifyPhoneNumberUser(callerName);
        $scope.modifyPhoneNumberIVR(callerName); 
        for (var key in extraHeaders) {
            console.log("key="+key+".val="+extraHeaders[key]);
        }
        $('#status_txt').text('Incoming Call');
        $('#incoming_callbox').show('slow');
        $('#btn-container').hide();
        $scope.answerW();
        $scope.playAudio();

    }

    $scope.salesIncomingCall = function(callerName, extraHeaders){
        $scope.incomingCallRinging = true;
        $scope.phoneNumberIncoming = callerName;
        $scope.resetSalesPages()
        $scope.salesLayout = true;
        $scope.staticQuestionsLayout = true;
        $scope.getsalesAgentStats();
        // $scope.incomingCallRinging = true;
        // $scope.getsalesCallerDetails();
        $scope.modifyPhoneNumberUser(callerName);
        for (var key in extraHeaders) {
            console.log("key="+key+".val="+extraHeaders[key]);
        }
        $('#status_txt').text('Incoming Call');
        $('#incoming_callbox').show('slow');
        $('#btn-container').hide();
        $scope.answerW();
        $scope.playAudio();
    }

    function onIncomingCall(callerName, extraHeaders) {
        if($scope.role == "useragent"){
            $scope.userIncomingCall(callerName, extraHeaders)
        }else if($scope.role == "salesagent"){
            $scope.salesIncomingCall(callerName, extraHeaders)
        }
    }

    // Guard para evitar loops de retry sobre onLoginFailed.
    var sipRepairAttempted = false;

    function onLogin() {
        console.log("entered login")
        // Pide credenciales SIP frescas al backend; el backend repara el endpoint
        // en Plivo si está huérfano. Hace fallback al comportamiento previo si falla.
        sipRepairAttempted = false; // reset en cada nuevo onLogin
        var fallbackUsername = username_agent;
        var fallbackPassword = 'plivoh';
        var role = $scope.role;
        var endpointPath = role === 'salesagent'
            ? '/japi/salesagent/sip-credentials/'
            : '/japi/useragent/sip-credentials/';
        if (!userId) {
            console.warn('[onLogin] sin userId, usando credenciales por defecto');
            plivoWebSdk.client.login(fallbackUsername, fallbackPassword);
            return;
        }
        $http.get(endpointPath + userId)
            .then(function(response) {
                var data = response && response.data && response.data.data;
                if (data && data.sipUsername && data.sipPassword) {
                    console.log('[onLogin] credenciales SIP obtenidas del backend');
                    plivoWebSdk.client.login(data.sipUsername, data.sipPassword);
                } else {
                    console.warn('[onLogin] respuesta sin credenciales, usando fallback');
                    plivoWebSdk.client.login(fallbackUsername, fallbackPassword);
                }
            })
            .catch(function(err) {
                console.error('[onLogin] error obteniendo credenciales SIP, usando fallback', err);
                plivoWebSdk.client.login(fallbackUsername, fallbackPassword);
            });
    }
    function  onMediaPermission (result) {
        if (result) {
            console.log("get media permission");
        } else {
            alert("you don't allow media permission, you will can't make a call until you allow it");
        }
    }
    function webrtcNotSupportedAlert() {
        console.log("heyyyyyyyyyyyyyyy");
        $('#txtStatus').text("");
        alert("Your browser doesn't support WebRTC.Please use latest version of chrome/firefox/opera/IE Edge");
    }
    
    // function onLogin() {
    //     console.log("onlogin");
    //     $('#status_txt').text('Logged in');
    // }
    function onLoginFailed() {
        $('#status_txt').text("Login Failed");
        // Si el primer login fall\u00f3, le pedimos al backend que recree el endpoint en Plivo
        // (delete + create) y reintentamos UNA sola vez para evitar loops.
        if (sipRepairAttempted) {
            console.error('[onLoginFailed] reintento ya hecho, no insistimos');
            return;
        }
        sipRepairAttempted = true;
        if (!userId) {
            console.warn('[onLoginFailed] sin userId, no se puede reparar');
            return;
        }
        var role = $scope.role;
        var endpointPath = role === 'salesagent'
            ? '/japi/salesagent/sip-credentials/'
            : '/japi/useragent/sip-credentials/';
        console.warn('[onLoginFailed] solicitando reparaci\u00f3n del PlivoEndpoint y reintentando login');
        $http.get(endpointPath + userId + '?repair=true')
            .then(function(response) {
                var data = response && response.data && response.data.data;
                if (data && data.sipUsername && data.sipPassword) {
                    console.log('[onLoginFailed] credenciales reparadas, reintentando login');
                    plivoWebSdk.client.login(data.sipUsername, data.sipPassword);
                } else {
                    console.error('[onLoginFailed] backend no devolvi\u00f3 credenciales tras repair');
                }
            })
            .catch(function(err) {
                console.error('[onLoginFailed] error en repair', err);
            });
    }
    // function onReady() {
    //     console.log("onReady...");
    //     login();
    // }
    function mute() {
        plivoWebSdk.client.mute();
        $('#linkUnmute').show('slow');
        $('#linkMute').hide('slow');
    }
    function unmute() {
        plivoWebSdk.client.unmute();
        $('#linkUnmute').hide('slow');
        $('#linkMute').show('slow');
    }

    $scope.hangupW = function() {
        console.log("entered hangupW")
        $scope.meal_index = 0;
        $scope.meal_index_1 = 0;
        $scope.dataNew = {};
        $scope.callClosed = true;
        $scope.onHangupCallStatus = true;
        console.log($scope.onHangupCallStatus, "get this value")
        $scope.liveNow = true;
        $scope.answeredCall = true;
        $scope.incomingCallRinging = true;
        $scope.totalAnswered = true;
        // Set onHangupCallStatus to true to indicate PAUSED status
        // $scope.liveNow = true;
        // $scope.answeredCall = false;
        // $scope.incomingCallRinging = false;
        // $scope.totalAnswered = false;
        if($scope.getuserRole == 'useragent'){
             $scope.totalLayout = false;
            $scope.dynamicLayout == false
         }else if($scope.getsalesRole == 'salesagent'){
            $scope.salesLayout = false;
             $scope.staticQuestionsLayout = false;
         }
        $('#status_txt').text('Hanging up..');
        plivoWebSdk.client.hangup();
        $('#btn-container').hide();
        $('#incoming_callbox').hide();
        $('#status_txt').text('Paused');
        //$scope.postAgentAvailableStatus();
    } 

    $scope.salesStatusW = function() {
        console.log("entered waiting state")
        $scope.meal_index = 0;
        $scope.meal_index_1 = 0;
        $scope.dataNew = {};
        $scope.callClosed = true;
        $scope.onHangupCallStatus = false;
        console.log( $scope.onHangupCallStatus, "after testing this value")
        $scope.liveNow = true;
        $scope.answeredCall = false;
        $scope.incomingCallRinging = false;
        $scope.totalAnswered = false;
        if($scope.getuserRole == 'useragent'){
             $scope.totalLayout = false;
            $scope.dynamicLayout == false
         }else if($scope.getsalesRole == 'salesagent'){
            $scope.salesLayout = false;
             $scope.staticQuestionsLayout = false;
         }
        $('#status_txt').text('Hanging up..');
        plivoWebSdk.client.hangup();
        $('#btn-container').hide();
        $('#incoming_callbox').hide();
        $('#status_txt').text('Ready');
        //$scope.postAgentAvailableStatus();
    }

    function dtmf(digit) {
        //console.log("send dtmf="+digit);
        plivoWebSdk.client.send_dtmf(digit);
    }
    function onCallTerminated(evt) {
        if ($scope.role === 'salesagent') {
            // $scope.salesEndDisposition = true;
            // console.log("after making disposition value to true",$scope.salesEndDisposition)
            $scope.callClosed = true;
            $scope.answeredCall = false;
            $scope.incomingCallRinging = false;
            $scope.totalAnswered = false;
            $scope.getsalesAgentStats(); 
            $scope.resetSalesPages()
            $scope.showDispositionsForSales()
            return;
        }

        console.log("terminated"+JSON.stringify(evt));
        if(evt.reason=="RTP Timeout"){
        $scope.goLive(false);
        $scope.meal_index = 0;
        $scope.meal_index_1 = 0;
        $scope.dataNew = {};
        $scope.callClosed = true;
        $scope.answeredCall = false;
        $scope.incomingCallRinging = false;
        $scope.totalAnswered = false;
        $scope.totalLayout = false;
        $scope.dynamicLayout = false;
       // $scope.postAgentAvailableStatus(); 
        // $scope.saveLeadUserDetails();
        $scope.playAudio();
        $scope.frwdOfferData={};//added
        }
        if(evt.originator=="remote" && $scope.forwardflag==false){
            $scope.hangupCall();
        }
        else{
        $scope.meal_index = 0;
        $scope.meal_index_1 = 0;
        $scope.dataNew = {};
        $scope.callClosed = true;
        $scope.answeredCall = false;
        $scope.incomingCallRinging = false;
        $scope.totalAnswered = false;
        $scope.totalLayout = false;
       // $scope.postAgentAvailableStatus(); 
        // $scope.saveLeadUserDetails();
        $scope.playAudio();
        $scope.frwdOfferData={};//added
        }
    }
    function onCallFailed(reason){
        console.info('onCallFailed vasu',reason);
    }
    function onIncomingCallCanceled(){
        $scope.$apply(function () {
            console.log("heyyyyy")
            $scope.callClosed = true;
            $scope.incomingCallRinging = false;
            $scope.totalLayout = false;
            $scope.dynamicLayout = false;
        });
    }
    $scope.logoutPlivo = function(){
        function onLogout(){
        console.info('onLogout');
    }
    }

    $scope.logout = function () {
        var callbacks = {
          success: function(data) {
            if ( data.statusCode == 200 ) {
                window.clearInterval(timerInter)
                $state.go('access.login');
            }
            else{
              toaster.pop('error', 'Error', data.message);
            }
          },
          failure: function(data) {
            toaster.pop('error', 'Error', data.message);
          }
        };
        UserService.logout($scope.user_id, $scope.role, callbacks);
      }

    var plivoWebSdk; 
    $scope.initPhone = function(){
        console.log("initPhon");
        //var options = refreshSettings();
        // Disable Plivo telemetry (enableTracking:false); explicitly enable quality tracking
        const options = {disableRtpTimeOut: true,debug:"DEBUG",permOnClick:true,enableTracking:false, enableQualityTracking:"all" ,enableNoiseReduction: true};

        console.log("disableRtpTimeOut obj---> " +JSON.stringify(options));
        plivoWebSdk = new window.Plivo(options);

        //plivoWebSdk = new window.Plivo();  
        console.log(plivoWebSdk,"this plivoWebSdk");
        plivoWebSdk.onLogin = onLogin();

        plivoWebSdk.client.on('onWebrtcNotSupported',webrtcNotSupportedAlert);
        plivoWebSdk.client.on('onLoginFailed', onLoginFailed);
        plivoWebSdk.client.on('onCallFailed', onCallFailed);
        plivoWebSdk.client.on('onCallTerminated', onCallTerminated);
        plivoWebSdk.client.on('onIncomingCall', onIncomingCall);
        plivoWebSdk.client.on('onMediaPermission' ,onMediaPermission);
        plivoWebSdk.client.on('onIncomingCallCanceled', onIncomingCallCanceled);
        console.log('initPhone ready!');
        }
    
    $scope.runNow = function(){
        console.log("entered here")
         $( document ).ready(function() {
            console.log( "HTML ready!" );
            $scope.initPhone();
        });
    }

    $scope.handleSuccess = function(stream) {
        if (window.stream) {
        //   window.stream.getAudioTracks().forEach(track => track.stop());
          angular.forEach(window.stream.getAudioTracks(), function(item, index) {
            item.stop()
          });
          window.stream = null;
        } else {
          var audio = document.createElement('audio');
          audio.controls = true;
          audio.autoplay = true;
          window.stream = stream;
          audio.srcObject = stream;
      
          stream.oninactive = function() {
            console.log('Stream ended');
          };
        }
    }
       
      $scope.handleError = function(e){
        console.log("ruin", e.message);
      } 

    //Test Microphone
    $scope.micTextButton = 'Test Microphone'
    $scope.isMicrophoneActive = false;
    
      $scope.testMicrophone = function() {
        if ($scope.isMicrophoneActive) {
            stopMicrophone();
        } else {
            startMicrophone();
        }
      } 

      function startMicrophone() {
        // console.log("started microphone")
        $scope.micTextButton = "Stop Test"
        $scope.isMicrophoneActive = true;
        if (navigator.mediaDevices) {
            var constraints = {
                audio: true,
                video: false
            };
            navigator.mediaDevices.getUserMedia(constraints)
                .then(function(stream) {
                    $scope.handleSuccess(stream);
                })
                .catch($scope.handleError);
        }
    } 

    function stopMicrophone() {
        // console.log("stop microphone")
        $scope.micTextButton = "Test Microphone"
        $scope.isMicrophoneActive = false;
        if (window.stream) {
            angular.forEach(window.stream.getAudioTracks(), function(track, index) {
                track.stop();
            });
            window.stream = null;
        }
    } 

    //   $scope.runMicFunction = function(){
    //     console.log("log on microphone test")
    //      $( document ).ready(function() {
    //         console.log("log here -----1")
    //         document.querySelector("#micTest").addEventListener('click', function(){
    //             console.log("log here ----2")
    //             if ( window.stream ) {
    //                 document.querySelector("#micTest span").innerHTML = "Test Microphone"
    //             } else {
    //                 document.querySelector("#micTest span").innerHTML = "Stop Test"
    //             }
    //             if (navigator.mediaDevices) {
    //               var constraints = window.constraints = {
    //                 audio: true, 
    //                 video: false
    //               }
    //               navigator.mediaDevices.getUserMedia(constraints).then($scope.handleSuccess).catch($scope.handleError)
    //             }
    //           });
    //     });
    // }
    // $scope.runMicFunction(); 

    $scope.changeStatus = function() {
        $scope.showValue = window.localStorage.getItem("show_value")
        
        if($scope.showValue == 'true') {
            $scope.openCallSetupStationModal($scope.switchStatus);
        } else {
            $scope.switchStatus = !$scope.switchStatus;
            $scope.goLive($scope.switchStatus);
            $scope.netConnect();
        }
      }

    // $scope.openModal = function() {
    //     console.log($scope.switchStatus," -------- $scope.switchStatus")
    //     //Open the modal
    //     $scope.showValue = window.localStorage.getItem("show_value")
    //     console.log( $scope.showValue, "get local storage value when modal is opened ")
    //     if($scope.showValue == 'true') {
    //         $scope.openCallSetupStationModal($scope.showValue);
    //     } else {
    //         console.log($scope.switchStatus, "from on/off button")
    //         $scope.goLive($scope.switchStatus);
    //         $scope.netConnect();
    //     }
    // };


    $scope.goLive = function(status) {
        console.log(status,"golive status")
        if(status == true){
            $scope.liveNow = true;
            $scope.switchStatus = true;
            $scope.statusValue = 'online';
            console.log($scope.statusValue)
            $scope.runNow();
            // $scope.postConnectionDetails();
        }
        else{
            $scope.liveNow = false;
            $scope.switchStatus = false;
            $scope.statusValue = 'offline';
            console.log( $scope.switchStatus)
            $scope.logoutPlivo();
            if($scope.role == 'useragent'){
                $scope.getAgentStats();
            }
            else if ($scope.role == 'salesagent'){
                $scope.getsalesAgentStats();
            }
        }
                var callbacks = {
                success: function(data) {
                    
                },
                failure: function(data) {
                    toaster.pop('error', 'Error', data.data);
                }
            };
            UserService.postAgentStatusUpdate({"status":$scope.statusValue},userId,$scope.role,callbacks);
    }; 

    $scope.openCallSetupStationModal = function(status) {
            var modalInstance = $modal.open({
                templateUrl: 'tpl/blocks/call_setup_station.html',
                controller: 'CallSetupStationCtrl',
                size: 'md',
                backdrop: 'static',
                resolve: {
                    object: function () {
                        return {
                            // status: status,
                            firstName:$scope.username_firstName,
                            lastName:$scope.username_lastName,
                            id:$scope.user_id,
                            role:$scope.role,
                        }
                    }
                }
            });
    
            modalInstance.result.then(function (selectedItem) {
                $scope.selected = selectedItem;
                if($scope.selected){ 
                  $scope.showValue = false; 
                  $scope.switchStatus = true;
                  $scope.goLive($scope.selected);
                  $scope.netConnect();
                  window.localStorage.setItem("show_value", false);
              } else {
                  var element = document.getElementById('custom-toggle-box');
                  if (element) {
                      element.click();
                  }
                  $scope.switchStatus = false;
              }
          }, function () {
           
          });
    }
     
    $scope.getAgentStatus = function(){
        var callbacks = {
        success: function(data) {
            console.log(data.data,"this is the status data")
            if(data.data.status == 'online'){
                console.log(data.data,"----- on state")
                $scope.goLive(true);                
            }else{
                $scope.goLive(false);
            }
        },
        failure: function(data) {
            toaster.pop('error', 'Error', data.data);
        }
        };
        UserService.getAgentStatus(userId,$scope.role,callbacks);
    }
    $scope.getAgentStatus();

    var sec = 0;
    function pad ( val ) { return val > 9 ? val : "0" + val; }
    setInterval( function(){
        $("#seconds").html(pad(++sec%60));
        $("#minutes").html(pad(parseInt(sec/60,10)));
    }, 1000);

    var sec1 = 0;
    function pad1 ( val ) { return val > 9 ? val : "0" + val; }
    setInterval( function(){
        $("#seconds1").html(pad(++sec1%60));
        $("#minutes1").html(pad(parseInt(sec1/60,10)));
    }, 1000);

    var sec2 = 0;
    function pad2 ( val ) { return val > 9 ? val : "0" + val; }
    setInterval( function(){
        $("#seconds2").html(pad(++sec2%60));
        $("#minutes2").html(pad(parseInt(sec2/60,10)));
    }, 1000);

    var sec3 = 0;
    function pad3 ( val ) { return val > 9 ? val : "0" + val; }
    setInterval( function(){
        $("#seconds3").html(pad(++sec3%60));
        $("#minutes3").html(pad(parseInt(sec3/60,10)));
    }, 1000);

   
    $scope.hangupCall = function(){
        console.log("hangupcall");
        $scope.onHangupCallStatus = true;
        /*$scope.postAgentAvailableStatus();
            $scope.hangupW();          
           $scope.getAgentStats();*/
           $scope.frwdOfferData={};//added 
           $scope.dis_data={};
           $scope.meal_index = 0;
            $scope.meal_index_1 = 0;        
            $scope.totalLayout = false;
            // $scope.salesLayout = false;
            document.getElementById("disposition").style.display='block';
            document.getElementById("disposition").style.opacity=1;        
            document.getElementById("disposition").style.backgroundColor = 'rgb(' + 0 + ',' +0 + ',' + 0 + ',' +0.34 +')';  
            document.getElementById("myModal1").style.display='none';
            document.getElementById("myModal2").style.display='none';
            document.getElementById("myModal3").style.display='none';
            document.getElementById("myModal4").style.display='none';
            var modal5 = document.getElementById("myModal5");
            if (modal5) modal5.style.display = "none";
 
             /*setTimeout for dispositions popup*/
             if($("#disposition").is(":visible")){
               //  setTimeout(function(){$scope.closeDisposition()}, 60000);
                window.clearTimeout(timer);
             timer = setTimeout(function(){$scope.closeDisposition()}, 60000);
             }

    }

    $scope.resetSalesPages = function() {
        // console.log("clear data here" )
        $scope.staticCustomerDetails = {
            first_name: '',
            last_name: '',
            gender: null ,
            email: null,
            zip_code: null,
            street1: '',
            street2: '',
            dobMonth: '',
            dobDay: '',
            dobYear: '',
            height_feet: '',
            height_inches: '',
            weight: '',
            face_value: '',
            tobacco_user: null,
            selectionDiesases: [],
            bank_account: null
          };

        $scope.editFaceValue = {};
        $scope.editingFaceValue = false; 
        $scope.showNoOffersMessage = false;
        $scope.editData = {};
        $scope.selectedDisposition.value = null;

        $scope.staticQuestionsLayout = false;
        $scope.staticPriorityLayout = false;
        $scope.salesDisposition = false;
        $scope.salesEndDisposition = false;
        $scope.selectedDisposition = {
            value: ''
         };
        // console.log("reset function scope.selectedDisposition ",$scope.selectedDisposition)
    }

        //added- dispositions -start
        $scope.showDispositionsForSales=function(){  
            // console.log("show this dispositions")
            $scope.staticQuestionsLayout = false;
            $scope.staticPriorityLayout = false;
            $scope.salesDisposition = false;   
            $scope.salesLayout = false;
            $scope.salesEndDisposition = true;
            document.getElementById("previousbutton").style.display='none';
           
        }

        $scope.activateAgent=function(disposition_type){
            console.log(disposition_type,"log here ----1")
            if(disposition_type == "" || disposition_type==undefined){
                toaster.pop('error', 'Error', 'Please select a disposition',2000);
            }
            else{
                console.log("when user end call")
            document.getElementById("disposition").style.display='none';
             angular.element(".modal-backdrop").removeClass("modal-backdrop"); //added to remove black screen
             $scope.forwardflag = false;                  
             var callbacks = {
                success: function(data) {
                },
                failure: function(data) {
                }
            };
       UserService.postDispositions($scope.scriptCallId,disposition_type,callbacks);
        $scope.postAgentAvailableStatus();
                    $scope.hangupW();          
                    $scope.getAgentStats();
                    $scope.disposition_type="";
        }
        }

        /*function when agent doesnt subit before 60sec*/
        $scope.closeDisposition=function(){
            if($("#disposition").is(":visible")){
            document.getElementById("disposition").style.display='none'; 
            $scope.disposition_type = "Not Submitted any Disposition"; 
             $scope.forwardflag = false;                  
              angular.element(".modal-backdrop").removeClass("modal-backdrop"); //added to remove black screen
             var callbacks = {
                success: function(data) {
                },
                failure: function(data) {
                }
            };
       UserService.postDispositions($scope.scriptCallId,$scope.disposition_type,callbacks);
        $scope.postAgentAvailableStatus();
                    $scope.hangupW();          
                    $scope.getAgentStats();
                    $scope.disposition_type="";
                }
                else{
                }
        }
        //added - dispositions -end


    // $scope.transferCall = function(offerId){
    //     var callbacks = {
    //         success: function(data) {
    //             $scope.totalLayout = false;
    //             $scope.incomingCallRinging = false;
    //             if(data.data == 'Success'){
    //                 toaster.pop('success', 'Success', 'Successfully transferred the call', 2000);
    //             }
    //             else{
    //                 toaster.pop('error', 'Error','There are no available offers', data.data);   
    //             }
                
    //         },
    //         failure: function(data) {
    //             toaster.pop('error', 'Error', data.data);
    //         }
    //     };
    //     UserService.getOfferTransfer(offerId,$scope.userDetails.call_id,0,callbacks);
    // }

    // $scope.transferCallModel = function(){
    //     $scope.transferCall($scope.offerDetails.offer_id);
    // }

    // $scope.getOfferDetails = function(id){
    //      var callbacks = {
    //         success: function(data) {
    //             $scope.offerDetails = data.data.available_offers;
    //             $scope.offerDetailsFlag = true;
    //         },
    //         failure: function(data) {
    //             toaster.pop('error', 'Error', data.data);
    //         }
    //     };
    //     UserService.getOfferDetailsFinal(id,$scope.userDetails.call_id,$scope.userDetails.state,$scope.userDetails.campaign_id,callbacks);
    // }

    $scope.nextForwardCall = function(readData,questions,optId,index,answer){
        $scope.forwardData = {"read_data":readData,"user_answer":answer,"opt_id":optId,"script_id":$scope.scriptCallId};
        // editscript --> storing the response - start
        if(answer != ""){
         //questions[index].result=answer;
         questions[index].response=answer;
         $scope.rightblock=true;
        }
        // editscript --> storing the response - end
    }

    $scope.callScreenPage = function() {
        console.log("home screen")
        $scope.currentPage = 'home';
        if($scope.callHistory === true){
                console.log("false on home screen")
                $scope.call_history = window.localStorage.setItem("call_history", false);
        }else {
            console.log("true on call history")
            $scope.call_history = window.localStorage.setItem("call_history", true);
        }

    }

    $scope.agentCallHistory = function(){
        $scope.salesLayout = false;
        $scope.staticQuestionsLayout = false;
        $scope.staticPriorityLayout = false;
        $scope.salesDisposition = false;
        $scope.tableContentLoading = true;
        $scope.currentPage = 'callhistory';
        console.log($scope.currentPage, "current page")
        $scope.call_history = window.localStorage.getItem("call_history");
        console.log($scope.call_history, "from call history function")
        var callbacks = {
        success: function(data) {
           $scope.callHistoryData = data.data;
           $scope.tableContentLoading = false;
        // $scope.openCopyConfirmationModal();
            },
        failure: function(data) {
            $scope.tableContentLoading = false;
            }
        };
        //UserService.getCallHistory(callbacks);
        UserService.getCallHistory(userId,$scope.role,callbacks); //added
    }

    $scope.hangupSalesCall = function(selected_disposition) { 
        console.log("hangup sales call", selected_disposition);
        $scope.postSalesDispositionsData(selected_disposition)
        $scope.openDispositionStatusModal(selected_disposition)
        $scope.hangupW();
        $scope.getsalesAgentStats(); 
        $scope.resetSalesPages(); 
    }
    
    /*$scope.forwardTheCall = function(){
            var callbacks = {
                success: function(data) {
                toaster.pop('success', 'Success', 'Forwarding the call', 2000);
                $scope.meal_index = 0;
                $scope.meal_index_1 = 0;
                $scope.dataNew = {};
                $scope.totalLayout = false;
                $scope.incomingCallRinging = false;
                $scope.putTransferAgentStatus();
                },
                failure: function(data) {
                    toaster.pop('error', 'Error', data.data);
                }
            };
            UserService.postAgentActions({"value":$scope.forwardData.user_answer},$scope.forwardData.opt_id,$scope.forwardData.script_id,callbacks);
    }*/

    $scope.updateFieldsAndSkipToNextQuestion = function(data,userAnswer,questions,optId,index,answer) {
        
        if(data.message == 'Data saved successfully'){
            //toaster.pop('success', 'Success', 'Data saved successfully', 2000);
            if(questions.length == index+1){
                $scope.nextQuestion();
            }else{
                $scope.next_1();
            }

           // editscript --> storing the response - start
            if(userAnswer != ""){
             questions[index].response=userAnswer;
             $scope.rightblock=true;
            }
            if((userAnswer == undefined && answer != "")||(userAnswer == "" && answer != "")){
             questions[index].response=answer;
             $scope.rightblock=true;
             }

             $("#sideLeadfield input").prop( "disabled", true );
                $("#sideLeadfield select").prop( "disabled", true );     
                $("#edit_right").prop( "disabled", false );
                $("#save_right").prop( "disabled", true );
            // editscript --> storing the response - end


            // $scope.updateLeadFields(questions[index].options[0].lead_field.code,userAnswer);
        }

    }


//added -start      
    $scope.forwardTheCall = function(userAnswer,questions,optId,index,answer){     
        var callbacks = {       
        success: function(data) {  
            console.log("forward call");        
            $scope.offerErrorCode=data.statusCode;      
            $scope.offerErrorMsg=data.message;      
           $scope.frwdOfferData = data.data; 
           console.log($scope.frwdOfferData)       
           $scope.frwdOfferData2=$scope.frwdOfferData; 
           if (data.data) {
               $scope.disableEdit();
           }

           if(data.statusCode==200){        
            document.getElementById("offerListFrwd").style.display='table';     
            //document.getElementById("offerStmt").style.display='block'; 
            document.getElementById("offerStmt").style.visibility='visible';   

            var modal5 = document.getElementById("myModal5");
            if (modal5) modal5.style.display = "none";
            //added
           
            if($scope.forwardData.read_data!=null){
                if(($scope.forwardData.read_data).includes("{offer_display_name}")){
                    $scope.forwardData.read_data=($scope.forwardData.read_data).replace(/{offer_display_name}/g,$scope.frwdOfferData[0].offer_name);
                }
              
                      document.getElementById("myModal1").style.display='block';      
                        document.getElementById("myModal1").style.opacity=1;        
                        document.getElementById("myModal1").style.backgroundColor = 'rgb(' + 0 + ',' +0 + ',' + 0 + ',' +0.34 +')';     
                        
                } 
           }

            if(data.statusCode==205){       
            document.getElementById("offerListFrwd").style.display='none';      
           // document.getElementById("offerStmt").style.display='none'; 
            document.getElementById("offerStmt").style.visibility='hidden'; 
            //no agents or no offers msg below
            var modal5 = document.getElementById("myModal5");
            if (modal5) {
            modal5.style.display = "block";
            modal5.style.opacity = 1;
            modal5.style.backgroundColor = "rgba(0,0,0,0.34)";
            }
            
            document.getElementById("myModal1").style.display='none'; 
            }  
            
            // new code for going to next question
            $scope.updateFieldsAndSkipToNextQuestion(data,userAnswer,questions,optId,index,answer);
             
        },
        failure: function(data) {       
            $scope.tableContentLoading = false;     
            toaster.pop('error', 'Error', data.data);       
            }       
        };      
         UserService.getForwardOfferData({"value":$scope.forwardData.user_answer},$scope.forwardData.opt_id,$scope.forwardData.script_id,callbacks);        
            //UserService.getForwardOfferData($scope.scriptCallId,callbacks);       
        }     
        
        
        $scope.onOfferSelect=function(offerselected,index){     
            console.log(offerselected);     
            console.log(index);     
            $scope.forwardflag = true;
           // document.getElementById("offerStmt").style.display='none'; 
            document.getElementById("offerStmt").style.visibility="hidden";           
        document.getElementById("disposition").style.display='none';        
            $scope.offerselect=offerselected.offer_id; 
            //added-start 
           for(var i=0;i<$scope.frwdOfferData2.length;i++){
                if(i!=index){
                    $('#button'+i).prop('disabled',true);
                }
            }  
            //added-end

            var callbacks = {       
                success: function(data) { 
                console.log(data,"get whole data");   
                $scope.concurreyResult=data.statusCode; 
                $scope.offerType = data.offer_type; 
                console.log($scope.offerType);
                //$scope.concurreyMsg=null;     
                        
                //error scenario        
                    if(data.statusCode==205){       
                        document.getElementById("myModal4").style.display='block';      
                        document.getElementById("myModal4").style.opacity=1;        
                        document.getElementById("myModal4").style.backgroundColor = 'rgb(' + 0 + ',' +0 + ',' + 0 + ',' +0.34 +')';     
                        
                         document.getElementById("disposition").style.display='none';  

                        var parent_button=document.getElementById("offerListFrwd");     
                        var child_button=parent_button.querySelectorAll("tr button");       
                        child_button[index].disabled=true;      
                        $scope.frwdOfferData=$scope.frwdOfferData2;
                        console.log("get forward data",$scope.frwdOfferData) ;
                        if($scope.role == 'useragent'){
                            $scope.totalLayout = true;  
                            $scope.dynamicLayout = true;     
                        } else if($scope.role == 'salesagent'){
                            $scope.salesLayout= true; 
                            $scope.staticQuestionsLayout = true;
                        }   
                        $scope.incomingCallRinging = true;      
                        $scope.liveNow=true;        
                        $scope.answeredCall = true;      
                        $scope.totalAnswered =true;     
                        $scope.concurreyMsg=data.message;  

                        //added-start 
                         for(var i=0;i<$scope.frwdOfferData2.length;i++){
                             if(i!=index){
                                    $('#button'+i).prop('disabled',false);
                             }
                             else{
                                $('#button'+index).prop('disabled',true);
                             }   
                         }  
                        //added-end  
                    }       
                    //success scenario      
                     if(data.statusCode==202){          
                        document.getElementById("myModal4").style.display='none';                          
                        $scope.concurreyMsg=null;       
                        toaster.pop('success', 'Success', 'Forwarding the call', 2000);     
                        $scope.meal_index = 0;      
                        $scope.meal_index_1 = 0;        
                        $scope.dataNew = {};        
                        
                        $scope.incomingCallRinging = false;     
                        $scope.frwdOfferData={};  
                        if($scope.getuserRole == 'useragent'){
                            $scope.totalLayout = false;      
                            $scope.dynamicLayout = false; 
                            // $scope.totalAnswered =true;    
                        } else if($scope.getsalesRole == 'salesagent'){
                            $scope.salesLayout= false; 
                            $scope.staticQuestionsLayout = false;
                        }      
                        angular.element(".modal-backdrop").removeClass("modal-backdrop");

                        document.getElementById("disposition").style.display='none';  
                        //UserService.putAgentTransferStatus(userId,callbacks);  
                        $scope.putTransferAgentStatus();
                        $scope.postAgentAvailableStatus();
                        
                     }              
                },      
                 failure: function(data) {      
                    $scope.tableContentLoading = false;     
                    toaster.pop('error', 'Error', data.data);       
                }       
             };     
            UserService.postSelectedOfferFrwd($scope.offerselect,$scope.scriptCallId,callbacks);                
            //$scope.frwdOfferData={};      
        } 

        $scope.errorPopupOk=function(){     
            $scope.concurreyMsg=null;       
            document.getElementById("myModal4").style.display='none';  

            $scope.offerErrorMsg=null;       
            var modal5 = document.getElementById("myModal5");
            if (modal5) modal5.style.display = "none"; 

            document.getElementById("myModal1").style.display='none';     
        }   

        
//added-end

    $scope.openCopyConfirmationModalData = function () {
        var forwardData = $scope.forwardData;
        var modalInstance = $modal.open({
            templateUrl: 'tpl/blocks/forward_call.html',
            controller: 'AgentDashboardCtrl',
            size: 'lg',
        });

        modalInstance.result.then(function (selectedItem) {
          $scope.selected = selectedItem;
      }, function () {
          $log.info('Modal dismissed at: ' + new Date());
      });
    };

        $scope.openCopyConfirmationModal = function () {
        var callHistory = $scope.callHistoryData;
        var modalInstance = $modal.open({
            templateUrl: 'tpl/blocks/call_history.html',
            controller: 'CallHistoryCtrl',
            size: 'lg',
            resolve: {
                object: function () {
                    return callHistory;
                }
            }
        });

        modalInstance.result.then(function (selectedItem) {
          $scope.selected = selectedItem;
      }, function () {
          $log.info('Modal dismissed at: ' + new Date());
      });
    };

    //Disposition status update 
    $scope.openDispositionStatusModal = function (status_disposition) {
        var selected_disposition = status_disposition;
        var modalInstance = $modal.open({
            templateUrl: 'tpl/blocks/disposition_status.html',
            controller: 'DispositionStatusCtrl',
            size: 'md',
            backdrop: 'static',
            resolve: {
                object: function () {
                    return {
                        dispositionStatus: selected_disposition,
                        user_id: $scope.user_id, 
                        role: $scope.role 
                    };
                }
            }
        });

        modalInstance.result.then(function (selectedItem) {
            console.log("call on result") 
          $scope.selected = selectedItem;
          console.log("get the disposition status",$scope.selected)
          $scope.salesStatusW();
          $scope.getAgentStatus();
      }, function () {
        //   $log.info('Modal dismissed at: ' + new Date());
      });
    };
 

    $scope.postSalesDispositionsData = function(selected_disposition) {
        if( selected_disposition != ''){
                var callbacks = {
                    success: function(data) {
                    },
                    failure: function(data) {
                    }
                };
                UserService.postsalesDispositions($scope.strNumber,selected_disposition,$scope.user_id,callbacks);
         }
     }

     //added-edit lead fields       
    $scope.editLeadFields=function(){       
        var div_lead=document.getElementById("sideLeadfield");      
        var input_lead=div_lead.querySelectorAll("input");      
        input_lead[0].disabled=false;       
        input_lead[1].disabled=false;       
        input_lead[2].disabled=false;       
        input_lead[3].disabled=false;       
        input_lead[5].disabled=false;       
        input_lead[6].disabled=false;       
        input_lead[9].disabled=false;       
        document.getElementById("edit_lead").style.display="none";      
    }

//added in case of browser close event
window.onbeforeunload = function() {
console.log('broswer close event');
$scope.stopConnectionCheck();
// $scope.statusValue = "offline";
// $scope.liveNow = false;
// console.log($scope.statusValue,$scope.liveNow,"on browser close event" )
if($scope.agstatus=='busy'){  
     /*$scope.$apply(function () {
        $scope.goLive(false);
    }); */ 
    plivoWebSdk.client.hangup();
     
 }
  return ; //no popup is returned
}

//checking internet connectivity

window.addEventListener('online', function(){
   console.log('Online');
   if(window.navigator.onLine==true && $scope.netflag==false){
    $scope.netflag=true;
    $scope.totalLayout=true;
    $scope.getAgentStatus();
    console.log("inside online event");
   }
});

window.addEventListener('offline', function(){
        console.log('lost internet --> Offline');
        if(window.navigator.onLine==false){
        $scope.netflag=false;
        $scope.goLive(false);
        $scope.meal_index = 0;
        $scope.meal_index_1 = 0;
        $scope.dataNew = {};
        $scope.callClosed = true;
        $scope.answeredCall = false;
        $scope.incomingCallRinging = false;
        $scope.totalAnswered = false;
        $scope.totalLayout = false;
        $scope.salesLayout = false;
        var modal5 = document.getElementById("myModal5");
        if (modal5) modal5.style.display = "none";
        document.getElementById("offerListFrwd").style.display='none';
        document.getElementById("myModal1").style.display='none';
        document.getElementById("myModal4").style.display='none';
        document.getElementById("disposition").style.display='none';  
    }
        //document.getElementsByClassName("switch-left")[0].style.display='none';

});

$scope.netConnect=function(){
     if(window.navigator.onLine==false){
        console.log("offline on toggle");
        $scope.goLive(false);
        $scope.meal_index = 0;
        $scope.meal_index_1 = 0;
        $scope.dataNew = {};
        $scope.callClosed = true;
        $scope.answeredCall = false;
        $scope.incomingCallRinging = false;
        $scope.totalAnswered = false;
         $scope.totalLayout = false;

    }
}

//editScript --> enable/disable edit for script answer --start

$scope.enableScriptEdit=function(){
$("#sideLeadfield input").prop( "disabled", false );
$("#sideLeadfield select").prop( "disabled", false );
$("#save_right").prop( "disabled", false );
$("#edit_right").prop( "disabled", true );
}

$scope.saveScriptEdit=function(){
    $scope.sidecondition=true;
   /*$("#sideLeadfield input").prop( "disabled", true );
    $("#sideLeadfield select").prop( "disabled", true );     
    $("#edit_right").prop( "disabled", false );
    $("#save_right").prop( "disabled", true );*/

    //validation -start
    if($("input[name='first_name']").val()==""){
        $("#sideLeadfield input").css("border-bottom","1px solid rgba(160, 160, 160, 0.2)");
        $("input[name='first_name']").css("border-bottom","1px solid red");
        toaster.pop('error', 'Error', 'Please enter vaild first name', 2000);
         $scope.sidecondition=false;
    }
    if($("input[name='last_name']").val()==""){
        $("#sideLeadfield input").css("border-bottom","1px solid rgba(160, 160, 160, 0.2)");
        $("input[name='last_name']").css("border-bottom","1px solid red");
        toaster.pop('error', 'Error', 'Please enter vaild last name', 2000);
        $scope.sidecondition=false;
    }
    if($("input[name='email']").val()==""){
        $("#sideLeadfield input").css("border-bottom","1px solid rgba(160, 160, 160, 0.2)");
        $("input[name='email']").css("border-bottom","1px solid red");
        toaster.pop('error', 'Error', 'Please enter vaild email address', 2000);
        $scope.sidecondition=false;
    }
    if($("input[name='dob']").val()==""){
        $("#sideLeadfield input").css("border-bottom","1px solid rgba(160, 160, 160, 0.2)");
        $("input[name='dob']").css("border-bottom","1px solid red");
        toaster.pop('error', 'Error', 'Please enter vaild date of birth', 2000);
        $scope.sidecondition=false;
    }
    if($("input[name='zipcode']").val()==""){
        $("#sideLeadfield input").css("border-bottom","1px solid rgba(160, 160, 160, 0.2)");
        $("input[name='zipcode']").css("border-bottom","1px solid red");
        toaster.pop('error', 'Error', 'Please enter vaild zip code', 2000);
        $scope.sidecondition=false;
    }
    if($("input[name='city']").val()==""){
        $("#sideLeadfield input").css("border-bottom","1px solid rgba(160, 160, 160, 0.2)");
        $("input[name='city']").css("border-bottom","1px solid red");
        toaster.pop('error', 'Error', 'Please enter vaild city', 2000);
        $scope.sidecondition=false;
    }
   if($("input[name='state']").val()==""){
    $("#sideLeadfield input").css("border-bottom","1px solid rgba(160, 160, 160, 0.2)");
        $("input[name='state']").css("border-bottom","1px solid red");
        toaster.pop('error', 'Error', 'Please enter vaild state', 2000);
        $scope.sidecondition=false;
    }
    if(($("input[name='email']").val()!="") && ($("input[name='email']").val()!=undefined) && ($("input[name='email']").val()!=null)){
        $("#sideLeadfield input").css("border-bottom","1px solid rgba(160, 160, 160, 0.2)");
        var sidemail=($("input[name='email']").val()).toLowerCase(); //added
                if(sidemail.match(/^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/)){
                   
                }
                else{
                    $("input[name='email']").css("border-bottom","1px solid red");
                     toaster.pop('error', 'Error', 'Please enter vaild email address',2000); 
                     $scope.sidecondition=false;                    
                    }
    }
    if(($("input[name='zipcode']").val()!="") && ($("input[name='zipcode']").val()!=undefined) && ($("input[name='zipcode']").val()!=null)){
        $("#sideLeadfield input").css("border-bottom","1px solid rgba(160, 160, 160, 0.2)");
        
        if(($("input[name='zipcode']").val()).match(/^[0-9]{5}$/)){}
        else{
            $("input[name='zipcode']").css("border-bottom","1px solid red");
           toaster.pop('error', 'Error', 'Please enter vaild zipcode',2000);   
           $scope.sidecondition=false;        
            }
    }

     if(($("input[name='dob']").val()!="") && ($("input[name='dob']").val()!=undefined) && ($("input[name='dob']").val()!=null)){
        $("#sideLeadfield input").css("border-bottom","1px solid rgba(160, 160, 160, 0.2)");
        
        if(($("input[name='dob']").val()).match(/^([0-9]{2})\/([0-9]{2})\/([0-9]{4})$/)){}
        else{
            $("input[name='dob']").css("border-bottom","1px solid red");
           toaster.pop('error', 'Error', 'Please enter vaild date',2000);   
           $scope.sidecondition=false;        
            }
    }
   /* for(var i=0;i<document.querySelectorAll('#sideLeadfield input').length;i++){
        if(document.querySelectorAll('#sideLeadfield input')[i].value!="" && document.querySelectorAll('#sideLeadfield input')[i].value!=undefined){
            $scope.sidecondition=true;
        }
    }*/
    if($scope.sidecondition==true){
        $("#sideLeadfield input").css("border-bottom","1px solid rgba(160, 160, 160, 0.2)");
        $("#sideLeadfield input").prop( "disabled", true );
    $("#sideLeadfield select").prop( "disabled", true );     
    $("#edit_right").prop( "disabled", false );
    $("#save_right").prop( "disabled", true );
     $scope.sidecondition=false;
        $scope.updateSideQustn();
    }
    //validation -end

    //$scope.updateSideQustn();
}
//editScript --> enable/disable edit for script answer --end

//editscript - onchange filter - start
$scope.onChangeFilter=function(currentobj)
{
    console.log(currentobj);
    for(var i=0;i<currentobj.options.length;i++){
    if(currentobj.options[i].answer==currentobj.response && currentobj.options[i].action.code =="forward"){
        $scope.filterobj=currentobj.options[i];
        $scope.forwardData = {"read_data":$scope.filterobj.read_text_first_data,"user_answer":$scope.filterobj.answer,"opt_id":$scope.filterobj.id,"script_id":$scope.scriptCallId};
    /*$scope.frwdOfferData={};  
    $scope.forwardTheCall(); 
    document.getElementById("scriptQustnCnt").style.visibility="hidden";*/

        }
    }
    
}
//editscript - update right questions

$scope.updateSideQustn = function(){
    $("#sideLeadfield input").prop( "disabled", true );
    $("#sideLeadfield select").prop( "disabled", true );
    $scope.scriptResponse.headers=$scope.scriptDetails;
    var callbacks = {
        success: function(data) {
            if(data.statusCode==200){
                toaster.pop('success', 'Success', data.data, 2000);

                //added-names left panel - start
                $scope.modifyPhoneNumberUser($scope.phoneNumberIncoming);
                 $scope.userDetails.first_name = $("input[name='first_name']").val();
                $scope.userDetails.last_name = $("input[name='last_name']").val();
                //added-names left panel - end

                if(Object.keys($scope.filterobj).length != 0){
                $scope.frwdOfferData={};  
                $scope.forwardTheCall('EditEd', null, null, null, null, null); 
                $scope.filterobj={};
                // document.getElementById("scriptQustnCnt").style.visibility="hidden";
                }
            }
            if(data.statusCode==205){
                toaster.pop('error', 'Error', data.data, 2000);
            }
        },
        failure: function(data) {
            //toaster.pop('error', 'Error', data.data);
        }
        };
        UserService.saveSideQustns($scope.scriptResponse,callbacks);
}
  
//   document.querySelector('#soundTest').addEventListener('click', function(){
//       var audio = document.createElement('audio');
//       audio.controls = true;
//       audio.autoplay = true;
//   })


  }]);